import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createFeedback } from '@/views/downLoadCenter/api/api';
export default {
  name: 'feedbackDialog',
  data: function data() {
    return {
      dialogVisible: false,
      addForm: {
        feedback_content: ''
      },
      subMitLoading: false
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this.subMitLoading = true;
          var params = _objectSpread({}, _this.addForm);
          createFeedback(params).then(function () {
            _this.$message.success('新建成功');
            _this.handleClose();
            _this.$emit('getList');
          }).finally(function () {
            _this.subMitLoading = false;
          });
        } else {
          _this.subMitLoading = false;
        }
      });
    },
    handleClose: function handleClose() {
      this.$refs.addForm.resetFields();
      this.dialogVisible = false;
    }
  }
};